import { render, staticRenderFns } from "./Filtering.vue?vue&type=template&id=a78068d6&scoped=true"
import script from "./Filtering.vue?vue&type=script&lang=js"
export * from "./Filtering.vue?vue&type=script&lang=js"
import style0 from "./Filtering.vue?vue&type=style&index=0&id=a78068d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78068d6",
  null
  
)

export default component.exports